var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRectangle54B = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 66 49",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "m19 47.999-.725-7.251a2.5 2.5 0 0 1 2.487-2.749h24.476a2.5 2.5 0 0 1 2.487 2.749l-.724 7.251H19Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#BABCC0",
  fillRule: "evenodd",
  d: "M17 47.999a1 1 0 0 1 1-1h30a1 1 0 1 1 0 2H18a1 1 0 0 1-1-1Z",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M27.793 3.274A2.5 2.5 0 0 1 30.283 1h5.434a2.5 2.5 0 0 1 2.49 2.274l.545 6A2.5 2.5 0 0 1 36.262 12h-6.524a2.5 2.5 0 0 1-2.49-2.726l.545-6Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#BABCC0",
  fillRule: "evenodd",
  d: "M29.738 2c-.686 0-1.314.388-1.62 1.002l-.223.445a1 1 0 1 1-1.79-.894l.223-.446A3.813 3.813 0 0 1 29.738 0h6.524c1.444 0 2.764.816 3.41 2.107l.223.446a1 1 0 1 1-1.79.894l-.222-.445A1.812 1.812 0 0 0 36.262 2h-6.524Z",
  clipRule: "evenodd"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M50.998 32.5a2.5 2.5 0 0 1-2.5 2.5h-31a2.5 2.5 0 0 1-2.5-2.5v-15a2.5 2.5 0 0 1 2.5-2.5h31a2.5 2.5 0 0 1 2.5 2.5v15ZM3.274 30.207A2.5 2.5 0 0 1 1 27.717v-5.433a2.5 2.5 0 0 1 2.274-2.49l6-.546A2.5 2.5 0 0 1 12 21.738v6.525a2.5 2.5 0 0 1-2.726 2.49l-6-.546Z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#BABCC0",
  fillRule: "evenodd",
  d: "M2 28.262c0 .687.388 1.314 1.002 1.621l.445.223a1 1 0 0 1-.894 1.789l-.446-.223A3.813 3.813 0 0 1 0 28.262v-6.524c0-1.444.816-2.764 2.107-3.41l.446-.222a1 1 0 0 1 .894 1.789l-.445.222A1.813 1.813 0 0 0 2 21.738v6.524Z",
  clipRule: "evenodd"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M62.726 19.793A2.5 2.5 0 0 1 65 22.283v5.434a2.5 2.5 0 0 1-2.274 2.49l-6 .545A2.5 2.5 0 0 1 54 28.262v-6.524a2.5 2.5 0 0 1 2.726-2.49l6 .545Z"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "#BABCC0",
  fillRule: "evenodd",
  d: "M64 21.738c0-.686-.388-1.314-1.002-1.62l-.445-.223a1 1 0 1 1 .894-1.79l.445.223A3.813 3.813 0 0 1 66 21.738v6.524a3.812 3.812 0 0 1-2.108 3.41l-.445.223a1 1 0 1 1-.894-1.79l.445-.222A1.812 1.812 0 0 0 64 28.262v-6.524Z",
  clipRule: "evenodd"
})));
SvgRectangle54B.viewBox = '0 0 66 49';
const ForwardRef = /*#__PURE__*/forwardRef(SvgRectangle54B);
export default ForwardRef;